module.exports = __webpack_public_path__ + "static/media/icecream.3d6334f5.png";